import React from 'react';
import { Box, LinearProgress, Skeleton, Typography } from '@mui/material';

const DIFFICULTIES = [
  { key: 'Easy', color: 'success.main' },
  { key: 'Medium', color: 'warning.main' },
  { key: 'Hard', color: 'error.main' },
];

const getRate = (accepted, total) => {
  if (!total) return 0;
  return Math.round((accepted / total) * 100);
};

const DifficultyBreakdown = ({ difficultyBreakdown, data, loading = false }) => {
  const source = difficultyBreakdown || data || {};

  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {[1, 2, 3].map((item) => (
          <Box key={item} sx={{ display: 'grid', gridTemplateColumns: '90px 1fr auto', gap: 1.5, alignItems: 'center' }}>
            <Skeleton variant="text" width={60} height={20} />
            <Skeleton variant="rounded" height={8} />
            <Skeleton variant="text" width={90} height={20} />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {DIFFICULTIES.map(({ key, color }) => {
        const total = source?.[key]?.total ?? 0;
        const accepted = source?.[key]?.accepted ?? 0;
        const rate = getRate(accepted, total);

        return (
          <Box key={key} sx={{ display: 'grid', gridTemplateColumns: '90px 1fr auto', gap: 1.5, alignItems: 'center' }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {key}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={rate}
              sx={{
                height: 8,
                borderRadius: 999,
                bgcolor: 'action.hover',
                '& .MuiLinearProgress-bar': { backgroundColor: color },
              }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {`${accepted}/${total} (${rate}%)`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default DifficultyBreakdown;
